<template>
  <a-tabs type="card" class="mb-2">
    <a-tab-pane key="1">
      <template #tab>
        <div class="d-flex align-items-center h-full">
          <Skeleton width="80px" />
        </div>
      </template>
      <div class="d-flex flex-column">
        <Skeleton width="40px" class="mb-1" />
        <div class="d-flex" style="gap: 20px;">
          <Skeleton width="100px" height="100px" class="mb-1" />
          <div>
            <div class="mb-2">
              <Skeleton width="70px" class="mb-1" />
              <Skeleton width="240px"/>
            </div>
            <div>
              <Skeleton width="110px" class="mb-1" />
              <Skeleton width="340px" />
            </div>
          </div>
        </div>
      </div>
    </a-tab-pane>
  </a-tabs>
</template>

<script>
import Skeleton from '@/components/custom/skeleton/Skeleton.vue'

export default {
  components: {
    Skeleton,
  },
}
</script>
